type ChevronRotate = 'up' | 'right' | 'down' | 'left'

const rotationMap: Record<ChevronRotate, string> = {
  down: 'rotate-0',
  left: '-rotate-90',
  up: 'rotate-180',
  right: 'rotate-90',
}

export const ChevronIcon = ({ className, rotate = 'down' }: { className?: string; rotate?: ChevronRotate }) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${rotationMap[rotate]} ${className ?? ''}`}
      aria-label={`Chevron ${rotate}`}
    >
      <title>{`Chevron ${rotate}`}</title>
      <path
        d="M12.75 0.75L6.75 6.75L0.75 0.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
